<template>
    <v-dialog
        v-model="dialog"
        content-class="farmer-datails-dialog"
        persistent
    >   
    <div class="farmer-details-container">
        <h2 class="--green mb-5"> Farmer Details </h2>
        <div class="farmer-card flex">
            <div class="flex">
                <img v-if="data.image" class="farmer-avatar mr-4"
                    :src="data.image.small" alt=""
                />
                <img v-else class="mr-3 farmer-avatar" src="https://cdn.pixabay.com/photo/2015/03/04/22/35/avatar-659652_960_720.png" alt="">

                <div>
                    <h3 v-if="data.full_name" class="font-weight-medium">{{data.full_name}}</h3>
                    <p v-if="data.address" class="text--secondary font-weight-medium">{{data.address.name}}</p>
                </div>
            </div>

            <div></div>
            <div class="">
                <p class="text--secondary font-weight-medium">Crops</p>
                <div class="crop_con">
                    <span >
                    <v-tooltip bottom :min-width="500" style="">
                        <template v-slot:activator="{ on, attrs }">                
                                <p  v-bind="attrs" v-on="on">{{cropdata}}</p>  
                        </template>
                
                        <span>{{cropdata}}</span>
                    </v-tooltip> 
                    </span>
                </div>
            </div>
            <div></div>
        </div>

        <div class="flex mid-con">
            <div>
                <h3 class="mb-5 text--secondary">Bought products</h3>
                <div v-if="productdata.length !== 0" class="product_con">
                    <div class="product_item" v-for="product in productdata" :key="product.id">
                        <product-card :data="product"/>
                    </div>
                </div>

                <div v-else class="noproduct">
                    <h4 class="font-weight-medium">{{data.full_name}} is yet to make a purchase on Krishify</h4>
                </div>
            </div>
            <div >
            <GmapMap
                :center="{lat:21.7679, lng:82}"
                :zoom="3.7"
                :options="{
                    zoomControl: false,
                    mapTypeControl: false,
                    scaleControl: false,
                    streetViewControl: false,
                    fullscreenControl: false,
                }"
                style="width : 250px; height: 330px;">
                <GmapMarker
                    :position="mapposition"
                    :clickable="false"
                    :icon="{url : marker, 
                            size: {width: 20, height: 20, f: 'px', b: 'px',}, 
                            scaledSize: {width: 20, height: 20, f: 'px', b: 'px',},
                            labelOrigin: {x: 128, y: 20}}" 
                ></GmapMarker>
            </GmapMap>
            </div>
        </div>

        <div class="buttons-section flex">
            <v-btn
                class="closebtn"
                @click="$emit('close')"
                v-ripple
                elevation="0"
                color="#F3F9F6"
                large
            >
                Close
            </v-btn>
            <v-btn
                @click="sendmessage = true"
                class="sendbtn"
                v-ripple
                elevation="0"
                color="#1D8D56"
                large
                :disabled="true"
            >
                Send Message
            </v-btn>
            
            <broadcast-modal :dialog="sendmessage" :headings="broadcastPageHeading" @close="sendmessage = false"/>
        
    </div>
    </div>
    <v-progress-linear
	    indeterminate
	    class="mt-1"
	    color="#1F8F58"
	    v-if="isproductdata"
    ></v-progress-linear>
    </v-dialog>
</template>


<script>
import productCard from './product-card.vue'
import broadcastModal from './broadcast-modal.vue'
import accessToken from "../../../../helpers/accessToken";
import API_URL from "../../../../helpers/apiUrls";

export default {
    name : 'farmerDetails',
    data() {
        return {
            farmerdetaildialog : this.farmerdialog,
            broadcastPageHeading : {},
            broadcastHeading : {
                placeholder : 'Write your message here...',
                note : '',
                type : 'chatdirect',
            },
            sendmessage : false,
            mapposition : {
                lat : 0,
                lng : 0,
            },
            marker : require("../../../../assets/MainDashboard/MyFarmers/mapMarker.svg"),
            productdata : [],
            isproductdata: false,
            cropdata: "",
        }
    },
    props : {
        dialog : {
            type: Boolean,
        },
        data : {
            type : Object,
        }
    },

    methods: {
        sendmethod(){
            this.sendmessage = true
        },
        closeall(){
            this.sendmessage = false
        }
    },

    watch:{
        data:function(){
            this.handlelocation(); 
            // this.getProductdetails();
            this.addcropdata();


        },
        dialog:function(){
            this.handlelocation();
            this.addcropdata();

            if(this.dialog){
                this.getProductdetails();
                this.broadcastHeading.heading = `Send message to ${this.data.full_name} through Krishify Chat`,
                this.broadcastPageHeading = this.broadcastHeading
                console.log("TEMP OBJ", this.broadcastPageHeading);
            }               
        }   
    },
    mounted(){
        this.broadcastHeading.heading = `Send message to ${this.data.full_name} through Krishify Chat`,
        this.broadcastPageHeading = this.broadcastHeading
        // this.handlelocation();
        // this.addcropdata();
        // if(this.data.id && this.dialog){
        //     console.log("GET PRODUCT API HJJWF");
        //     this.getProductdetails();
        // }   
        // console.log("DIALOG", this.dialog);
    },
    components : {
        'product-card' : productCard,
        'broadcast-modal' : broadcastModal,
    },

    methods:{
        addcropdata(){
            if(this.data.crops && this.data.crops.length > 0){
                for(var i = 0; i<this.data.crops.length-1; i++){
                    this.cropdata += this.data.crops[i].title;
                    this.cropdata += ", ";
                }
                this.cropdata += this.data.crops[this.data.crops.length-1].title;
            } else {
                this.cropdata = "";
            }
        },

        handlelocation(){
            if(this.data.address){
                if(this.data.address.position){
                    this.mapposition.lat = parseInt(this.data.address.position.lat);
                    this.mapposition.lng = parseInt(this.data.address.position.lon);
                }
            } else {
                    this.mapposition.lat = 0;
                    this.mapposition.lng = 0;                
            }
        },
        
        getProductdetails(){
            // console.log(this.data);
            this.isproductdata = true
            const successHandler = response => {
                if(response.status === 200) {
                    this.dataPresent = true
                    this.productdata = response.data.results;
                    this.isproductdata = false;
                }
            }
            const errorHandler = response => {
                this.showToast('Something went wrong internally!', 'error', 10000);
                this.isproductdata = false;
            }
            const headers = {
                'Authorization' : `Bearer ${accessToken.getAccessToken()}`,
                'BRAND-ID' : localStorage.getItem('Brand-ID') 
            }
            this.requestGET(
                `${API_URL.getuser_product}?user=${this.data.id}&data_per_page=${30}&page=${1}`,
                {},
                headers,
                successHandler,
                errorHandler,
               
            )            
        }
    }
}
</script>


<style lang="scss" scoped>
.farmer-datails-dialog{
    background-color: #FFFFFF;
}
.farmer-details-container{
    padding: 25px;

    h2{
        font-weight: 500;
    }
}
.farmer-card{
    justify-content: space-between;
    margin-bottom: 30px;
    p{
        margin: 0px;
    }
}
.farmer-avatar{
    margin-right: 10px;
    width: 49px;
    height: 49px;
}
.product_con{
    display: flex;
    max-width: 350px;
    // background-color: #1D8D56;
    overflow-x: scroll;
    flex-wrap: nowrap; 
}
.noproduct{
    display: flex;
    align-items: center;
    height: 200px;
}
.mid-con{
    justify-content: space-between;
    align-items: flex-start;
}
.vue-map-container{
    border-radius: 20px;
    width: 10px
}
.crop_con{
    width: 360px;
    overflow: hidden;
    white-space: nowrap;  
    text-overflow:ellipsis;
    p{
        display: block;
        width: 340px;
        overflow: hidden;
    white-space: nowrap;  
    text-overflow:ellipsis;
    }

}
.buttons-section {
	justify-content: space-between;
    margin-top: 40px;

    button{
        width: 49%;
        padding: 14px;
        font-weight: 600;
        align-self: flex-end;
        border-radius: 3px;
    }
}
.closebtn{
    background: rgba(49, 138, 54, 0.05);
    color: #1D8D56;
    height: 44px;
}
.sendbtn{
    background: #318535;
    color: #FFFFFF;
}
.v-tooltip__content{
  background-color: #FFFFFF;
  color: #000000;
  border: 0.6px solid #979797;
  border-radius: 5px;
  max-width: 250px;
  min-width: 200px;
  text-align: center;
  font-size: 13px;
  padding: 10px 12px;
  
}
</style>

<style lang="scss">
.farmer-datails-dialog.v-dialog {
	width: 55%;
    background-color: #FFFFFF;
}
</style>